import Check from 'assets/icons/checkBordered.svg';
import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'ui';

import s from './Checkbox.module.scss';

const cx = cn.bind(s);

const Checkbox = ({
  className,
  label,
  disabled,
  variant,
  error,
  showErrorMessage,
  size,
  align,
  value,
  onChange,
  ...attrs
}) => {
  const iconClassName = cx('icon', size, { error, disabled });
  const fakeCheckboxClassName = cx('fakeCheckbox', size, {
    error,
    disabled,
  });
  const renderCheckbox = () => (
    <>
      <input
        checked={value}
        type="checkbox"
        className={cx('inputCheckbox')}
        onChange={onChange}
        {...attrs}
      />
      <div className={fakeCheckboxClassName}>
        <Check className={iconClassName}/>
      </div>
    </>
  );

  return (
    <div className={cx('wrapper', className)}>
      {label ? (
        <label className={cx('label', { top: align === 'top', [`variant_${variant}`]: variant })}>
          {renderCheckbox()}
          {label}
        </label>
      ) : (
        renderCheckbox()
      )}
      {error && showErrorMessage && <ErrorMessage className={cx('errorMessage')} text={error} />}
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.element,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  showErrorMessage: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large']),
  align: PropTypes.oneOf(['center', 'top']),
  variant: PropTypes.oneOf(['brainable', '']),
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  label: null,
  value: false,
  disabled: false,
  align: 'center',
  error: '',
  variant: '',
  showErrorMessage: false,
  size: 'large',
  onChange: () => {
  },
};

export default Checkbox;
